/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.MeevoMessenger {
    'use strict';

    import IDataMaintenanceInfiniteList = Meevo.Components.BaseClasses.IDataMaintenanceInfiniteList;

    class ArrivalsSearchDeletedConversationListContoller implements ng.IComponentController {
        static $inject = [
            'meevo.AppSettings',
            'meevo.components.common.DataService',
            'meevo.plugins.meevoMessenger.meevoMessengerService',
            'meevo.plugins.meevoMessenger.meevoMessengerApiService',
            'meevo.components.busy.BusyService',
        ];
        
        public selectedConversation: MeevoMessengerConversation;
        public userHasAccessToViewPhoneNumber: boolean;
        private conversationFilter: string = "";
        private deletedConversationList: IDataMaintenanceInfiniteList;

        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected meevoMessengerService: IMeevoMessengerService,
            protected meevoMessengerApiService: IMeevoMessengerApiService,
            protected busyService: Meevo.Components.Busy.BusyService,
        ) { }

        $onInit() {
            this.getUndeleteConversationsList(this.getDefaultConversationBodyRequest());
        }

        private onSearchFilterChanged() {
            if (!this.userHasAccessToViewPhoneNumber && !isNaN(+this.conversationFilter)) return;

            const bodyRequest = this.meevoMessengerService.getFilterSettingsByFilterOption(_.extendOwn(
                this.getDefaultConversationBodyRequest(), { criteria: { filter: this.conversationFilter } }
            ), true);
            this.getUndeleteConversationsList(bodyRequest);
        }    

        private getUndeleteConversationsList(employeeBodyRequest: IConversationBodyRequest) {
            this.busyService.start();
            this.deletedConversationList = new Meevo.Components.BaseClasses.PagedResults(this.dataService, `${this.appSettings.API_ENDPOINTS.meevoMessenger}/Conversation/Deleted`, () => this.busyService.stop());
            this.deletedConversationList.initSearch(employeeBodyRequest);
        }

        private getDefaultConversationBodyRequest(isClientList: boolean = true): IConversationBodyRequest {
            return {
                filterPhoneNumber: null,
                filterFullName: null,
                isClientList: isClientList,
                isNewMessage: null,
                isFollowUp: null,
                debug: false,
                dateStart: null,
                dateEnd: null,
                isLastInbound: null,
                criteria: {
                    filter: null,
                },
                pageNumber: 0,
                classification: MeevoMessengerClassificationAPI.ARRIVALS,
                itemsPerPage: 25
            };
        }

        private get conversationStylesEnum() {
            return DeletedConversationStylesEnum;
        }
    }

    class ArrivalsSearchDeletedConversationListComponent implements angular.IComponentOptions {
        templateUrl = 'app/plugins/meevoMessenger/components/arrivalsDeletedConversationList/arrivalsDeletedConversationList.template.html';
        controller = ArrivalsSearchDeletedConversationListContoller;
        controllerAs = 'vm';
        bindings = {
            selectedConversation: '=',
            userHasAccessToViewPhoneNumber: '<',
        };
    }

    angular.module('meevo.plugins.meevoMessenger')
        .component('arrivalsSearchDeletedConversationList', new ArrivalsSearchDeletedConversationListComponent());

}

